'use strict';

exports.__esModule = true;
exports.ContentContainer = exports.LayoutContainer = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: #f5f5f5;\n  grid-template-areas: \'b a\' \'b c\';\n  overflow: hidden;\n  width: 100%;\n  direction: ', ';\n  ', ';\n'], ['\n  background-color: #f5f5f5;\n  grid-template-areas: \'b a\' \'b c\';\n  overflow: hidden;\n  width: 100%;\n  direction: ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    height: 100vh;\n    display: grid;\n    display: -ms-grid;\n    grid-template-columns: 75px auto;\n    ms-grid-column: 75px auto;\n    grid-template-rows: 60px auto;\n    ms-grid-row: 60px auto;\n  '], ['\n    height: 100vh;\n    display: grid;\n    display: -ms-grid;\n    grid-template-columns: 75px auto;\n    ms-grid-column: 75px auto;\n    grid-template-rows: 60px auto;\n    ms-grid-row: 60px auto;\n  ']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  grid-area: c;\n  max-height: calc(100vh - 60px);\n  overflow-y: auto;\n  padding: 20px;\n  ', '\n  ', '\n  ', ';\n'], ['\n  grid-area: c;\n  max-height: calc(100vh - 60px);\n  overflow-y: auto;\n  padding: 20px;\n  ', '\n  ', '\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n    min-height: Calc(100vh - 160px);\n    margin-bottom: 80px;  \n  '], ['\n    min-height: Calc(100vh - 160px);\n    margin-bottom: 80px;  \n  ']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n    min-height: Calc(100vh - 160px);\n    margin-bottom: 80px;\n  '], ['\n    min-height: Calc(100vh - 160px);\n    margin-bottom: 80px;\n  ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var LayoutContainer = exports.LayoutContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.language === 'en' ? 'ltr' : 'rtl';
}, function (props) {
  return props.theme.media.desktop(_templateObject2);
});

var ContentContainer = exports.ContentContainer = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.theme.media.phone(_templateObject4);
}, function (props) {
  return props.theme.media.tablet(_templateObject5);
}, function (props) {
  return props.extendContentContainer ? props.extendContentContainer : '';
});